import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { ParamsDataListStores, ParamsPageWebView } from 'utils/typeServices';

import { Box, Typography, Collapse } from '@mui/material';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import DatePicker from 'components/views/DatePicker';
import ParseWebView from 'components/views/ParseWebView';
import CardStore from 'components/views/Scheduling/CardStore';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

import { NumberSection, ContentCards, LinkExtermal } from './styles';
import PageErrorPendingTicket from 'components/views/ExchangeCenter/PageErrorPendingTicket';

const Scheduling = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [dateSelected, setDateSelected] = useState('');
    const [showModalExit, setShowModalExit] = useState(false);
    const [showInformative, setShowInformative] = useState(true);
    const [storeSelected, setStoreSelected] = useState<number>(0);
    const [modalErrorSchedule, setModalErrorSchedule] = useState(false);
    const [arrayDatesList, setArrayDatesList] = useState<Array<{
        date: string
    }>>();
    const [arrayListStores, setArrayListStores] = useState<Array<ParamsDataListStores>>();
    const { dataQuoteListservices, dataEffectSchedule, selectedCar, dataListStoresByZipCode, dataPerfilUser, dataConfirmOrder, dataGetListarCotacoes, dataErrorTicketOpen, handleErrorTicketOpen, handlePostGetListStoresByZipCode, handleParseProductCart, handleGetPerfilUser } = useContext(DataContext);
    const { register, watch, setValue } = useForm();

    const cep = watch('cep');

    const handlePostGetListStoresByZipCodeState = (cep: string) => {
        if (cep && dataQuoteListservices) {
            setIsLoading(true);
            handlePostGetListStoresByZipCode({
                token: localStorage.getItem('token')!,
                body: {
                    CD_PEDIDO: dataConfirmOrder ? dataConfirmOrder?.order?.cD_PEDIDO : dataGetListarCotacoes?.cD_PEDIDO_NOVO!,
                    DT_INICIO: new Date().toISOString(),
                    DT_VALIDADE_COTACAO: dataQuoteListservices?.dT_VALIDADE,
                    FL_DOMICILIAR: false,
                    NR_CEP_AGENDAMENTO: cep?.replace('-', ''),
                    NR_TIPO_AGENDAMENTO: 11
                },
            });
        }
    }

    const handleParseProductCartState = () => {
        if (dataGetListarCotacoes?.quoteItemsChooses && selectedCar) {
            handleParseProductCart({
                body: {
                    cD_COTACAO: dataGetListarCotacoes.quote.cD_COTACAO,
                    cD_PEDIDO: state.cD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                    quoteItemsChooses: dataGetListarCotacoes?.quoteItemsChooses
                }
            });
        }
    }

    useEffect(() => {
        if (dataListStoresByZipCode) {
            let listDates: Array<{ date: string }> = [];
            let listStores: Array<ParamsDataListStores> = [];
            dataListStoresByZipCode.map(({ DATAS_HORAS, LOJA }) => DATAS_HORAS.map(({ Data, Horarios }) =>
            (
                // eslint-disable-next-line no-sequences
                listDates.push({ date: Data }),
                listStores.push({
                    CD_LOJA: LOJA.CD_LOJA,
                    CD_UF: LOJA.CD_UF,
                    DS_PONTO_REFERENCIA: LOJA.DS_PONTO_REFERENCIA,
                    NM_BAIRRO: LOJA.NM_BAIRRO,
                    NM_CIDADE: LOJA.NM_CIDADE,
                    NM_ENDERECO: LOJA.NM_ENDERECO,
                    NOME_LOJA: LOJA.NOME_LOJA,
                    NR_CEP: LOJA.NR_CEP,
                    NR_DISTANCIA: LOJA.NR_DISTANCIA,
                    NR_NUMERO: LOJA.NR_NUMERO,
                    Date: Data,
                    Horarios: Horarios
                })
            )));

            setIsLoading(false);
            setArrayDatesList(listDates);
            setArrayListStores(listStores);
        }
    }, [dataListStoresByZipCode]);

    useEffect(() => {
        if (dataPerfilUser && selectedCar) {
            setValue('cep', dataPerfilUser.CEP_PERNOITE);
            handlePostGetListStoresByZipCodeState(dataPerfilUser.CEP_PERNOITE);
        }

        if (typeof dataPerfilUser === "undefined" && selectedCar) {
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPerfilUser]);

    useEffect(() => {
        if (dataEffectSchedule === false) {
            setModalErrorSchedule(true);
        }
    }, [dataEffectSchedule]);

    useEffect(() => {
        if (state?.isExchangesInProgress) {
            handleParseProductCartState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return (
        <ParseWebView stepActive={3} isWebView={isWebView} typePage='quotation' showShoppingCart={true}>
            { 
                dataErrorTicketOpen ?
                    <PageErrorPendingTicket isWebView={isWebView} handleErrorTicketOpen={handleErrorTicketOpen} />
                :
                showInformative ?
                <>
                    <Box sx={{ textAlign: 'center', margin: '0 auto', paddingBottom: '3rem', maxWidth: '32rem', 'a': { fontSize: '1rem', color: '#17A7E0', textDecoration: 'underline', fontWeight: 600 } }}>
                        <Box sx={{ 'svg': { maxHeight: '114px', opacity: '1' } }}>
                            <IcIturinCoverage />
                            <Typography sx={{ fontSize: '1.125rem', position: 'relative', fontWeight: '700', padding: '.875rem 0 .5rem', borderRadius: '10px', border: '1px solid #17A7E0', margin: '-27px auto 1.75rem', width: '20rem', backgroundColor: 'white' }}>
                                AVISOS IMPORTANTES!
                            </Typography>
                        </Box>
                        <Typography lineHeight='20px' sx={{
                            fontSize: { xs: '1rem', md: '1rem' }
                        }}>
                            &middot; É necessário realizar vistoria em loja<br />
                            (o novo plano escolhido só é considerado ativo, depois desta vistoria);<br /><br />
                            &middot; O veículo não pode ter avarias;<br /><br />
                            &middot; A documentação precisa estar regularizada.
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: { xs: '1rem', md: '1rem' },
                                padding: { xs: '2rem 0 .75rem', md: '2rem 0 .75rem' },
                                lineHeight: '19px',
                                maxWidth: '24rem',
                                margin: '0 auto'
                            }}>
                            Caso não seja o segurado quem irá levar o veículo, é
                            necessário imprimir e assinar o<br />
                            <b>“Termo de autorização para terceiros”.</b>
                        </Typography>
                        {isWebView ?
                            <Typography
                                sx={{
                                    fontSize: '1rem',
                                    color: '#17A7E0',
                                    fontWeight: 600,
                                    lineHeight: '1.2'
                                }}>
                                O termo será enviado por e-mail após a <br />
                                conclusão do agendamento.
                            </Typography>
                            :
                            <a href='/documents/AUTORIZACAO_TERCEIROS.pdf' target='blank' download={isWebView}>
                                Clique aqui e baixe o documento
                            </a>
                        }

                        <Box sx={{ width: '100%', maxWidth: '20rem', margin: { xs: '1.5rem auto 0', md: '2.31rem auto 0' }, 'button': { width: '100%', marginBottom: '.93rem' } }}>
                            <Typography fontSize='1rem' marginBottom='.75rem'>
                                Deseja continuar?
                            </Typography>
                            <ButtonRectangle name='SIM' onClick={() => setShowInformative(false)} />
                            <ButtonOutlined name='CANCELAR' onClick={() => { setShowModalExit(true); }} />
                        </Box>
                    </Box>

                    <Modals open={showModalExit}>
                        <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23.5rem' } }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0', padding: { xs: '1.75rem 1rem 1.75rem', md: '1.75rem 1.56rem 1.75rem' } }}>
                                <Typography sx={{ fontSize: '1.25rem', fontWeight: 700 }}>
                                    Poxa, que pena que desistiu!
                                </Typography>
                                <Typography sx={{ fontSize: '.93rem', paddingTop: '1rem', lineHeight: '19px' }}>
                                    Não se preocupe, a sua cotação <b>está guardada</b> e quando quiser volte e finalize de onde parou.
                                </Typography>
                            </Box>
                            <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: '2.125rem 3.8125rem 2.5rem', 'button': { width: '100%' } }}>
                                <ButtonRectangle name='Fechar' onClick={() => { setShowModalExit(false); setShowInformative(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`) }} />
                            </Box>
                        </Box>
                    </Modals>
                </>
                :
                <>
                    <Box>
                        <Typography sx={{ fontSize: '1.5rem', color: 'secondary.main', fontWeight: 700 }}>
                            Agendamento de Vistoria
                        </Typography>
                        <Typography sx={{ fontSize: '1rem', padding: '.75rem 0 1.3125rem' }}>
                            Digite o novo CEP para selecionar <strong>a data e local</strong> para a vistoria:
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            gap: '1.3125rem',
                            flexDirection: { xs: 'row', md: 'row' },
                            alignItems: 'flex-start',
                            'button': {
                                width: '11rem',
                                height: '2.8125rem',
                            },
                            '#box-input': {
                                maxWidth: '14rem',
                            }
                        }}>
                            <Input
                                name='cep'
                                label='CEP de referência'
                                placeholder='99999-999'
                                type='tel'
                                mask
                                register={{ ...register("cep", { pattern: Regex.cep }) }}
                                disabled={isLoading}
                            />
                            <Box sx={{ display: 'flex', gap: '.5rem', marginTop: '1.3rem' }}>
                                <ButtonRectangle name='PESQUISAR' loadingBtn={isLoading} onClick={() => handlePostGetListStoresByZipCodeState(cep)} />
                            </Box>
                        </Box>
                    </Box>

                    <Collapse in={!isLoading && (arrayDatesList ? true : false)}>
                        <Box>
                            <Box sx={{ display: 'flex' }}>
                                <NumberSection>
                                    2
                                </NumberSection>
                                <Typography fontSize='1.25rem' padding=".5rem 0 0 .685rem">
                                    Selecione a nova <strong>data e horário:</strong>
                                </Typography>
                            </Box>

                            <Collapse in={arrayDatesList ? true : false}>
                                <Box sx={{ display: 'flex', marginTop: '1.25rem', gap: '6.25rem' }}>
                                    <Box sx={{ maxWidth: 'fit-content' }}>
                                        {arrayDatesList && <DatePicker arrayListDates={arrayDatesList} handleDateSelected={(e) => setDateSelected(e)} />}
                                        <Box display='flex' justifyContent='space-between' padding='1.18rem 0 1.625rem'>
                                            <Box display='flex' alignItems='center'>
                                                <div style={{ width: '1.81rem', height: '1.81rem', background: '#D9D9D9', border: '2px solid #D9D9D9', borderRadius: 100 }} />
                                                <Typography fontSize='.81rem' paddingLeft='.5rem'>
                                                    Datas disponíveis
                                                </Typography>
                                            </Box>

                                            <Box display='flex' alignItems='center'>
                                                <div style={{ width: '1.81rem', height: '1.81rem', background: '#97C93D', border: '2px solid #97C93D', borderRadius: 100 }} />
                                                <Typography fontSize='.81rem' paddingLeft='.5rem'>
                                                    Data escolhida
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Collapse>

                            <Collapse in={arrayListStores ? true : false}>
                                <Box sx={{ width: '100%', maxWidth: { xs: '100%', md: '34rem' } }}>
                                    <Typography fontSize='1.25rem' fontWeight={700} paddingBottom='.5rem' textAlign='left'>
                                        LOJAS PARCEIRAS
                                    </Typography>
                                    <ContentCards>
                                        {arrayListStores?.map(({ NOME_LOJA, DS_PONTO_REFERENCIA, CD_LOJA, NR_DISTANCIA, NM_ENDERECO, NR_NUMERO, NR_CEP, NM_BAIRRO, NM_CIDADE, Date, Horarios }, index) =>
                                            dateSelected === Date &&
                                            <CardStore
                                                key={index}
                                                date={Date}
                                                hours={Horarios}
                                                NR_CEP={NR_CEP}
                                                CD_LOJA={CD_LOJA}
                                                isExchanges={true}
                                                NOME_LOJA={NOME_LOJA}
                                                NR_NUMERO={NR_NUMERO}
                                                NM_BAIRRO={NM_BAIRRO}
                                                NM_CIDADE={NM_CIDADE}
                                                NM_ENDERECO={NM_ENDERECO}
                                                NR_DISTANCIA={NR_DISTANCIA}
                                                DS_PONTO_REFERENCIA={DS_PONTO_REFERENCIA}
                                                isSelected={storeSelected}
                                                isStoreSelected={(e) => setStoreSelected(e)}
                                                isIndexStore={index}
                                                isWebView={isWebView}
                                            />
                                        )}
                                    </ContentCards>
                                </Box>
                            </Collapse>
                        </Box>
                    </Collapse>

                    <Modals open={modalErrorSchedule}>
                        <Box sx={{ width: { xs: 'calc(100vw - 2rem)', md: '26rem' }, textAlign: 'center' }}>
                            <Box sx={{ borderRadius: '8px 8px 0 0', padding: '1.8675rem 1rem .875rem' }}>
                                <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700, textAlign: 'center' }}>
                                    ATENÇÃO!
                                </Typography>
                                <Typography sx={{ fontSize: '.875rem', fontWeight: 600, paddingTop: '1rem', textAlign: 'center', lineHeight: '17px' }}>
                                    Tivemos um problema ao iniciar o seu agendamento. <br />
                                    Entre em contato com a nossa<br />
                                    Central de Atendimento:
                                </Typography>
                            </Box>
                            <Box sx={{
                                borderRadius: '0 0 8px 8px',
                                padding: { xs: '1.25rem 2rem 2rem', md: '1.25rem 3.81rem 2rem' },
                                backgroundColor: 'primary.main',
                                'button': {
                                    width: '100%',
                                    height: '2.5rem',
                                }
                            }}>
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                            São Paulo
                                        </Typography>
                                        <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                            Digite a opção 1,2
                                        </Typography>
                                    </Box>
                                    {isWebView ?
                                        <PhoneCopyWebView text='(011) 3616-9000' link='1136169000' />
                                        :
                                        <LinkExtermal href="tel:1136169000">
                                            (011) 3616-9000
                                            <LocalPhoneOutlinedIcon />
                                        </LinkExtermal>
                                    }
                                </Box>
                                <Box>
                                    <Typography fontSize='.75rem' color='white' paddingBottom='.2rem' textAlign='start'>
                                        Outras localidades
                                    </Typography>
                                    {isWebView ?
                                        <PhoneCopyWebView text='0800 774 2000' link='08007742000' />
                                        :
                                        <LinkExtermal href="tel:08007742000">
                                            0800 774 2000
                                            <LocalPhoneOutlinedIcon />
                                        </LinkExtermal>
                                    }
                                </Box>
                                <ButtonRectangle name='FECHAR' onClick={() => { navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`); }} />
                            </Box>
                        </Box>
                    </Modals>
                </>
            }
        </ParseWebView>
    );
}

export default Scheduling;